module.exports = __webpack_public_path__ + "img/yellowgold@2x.aad76ee.webp";